$(function() {
    $('.js-footer__open-list').on('click', function openFooterList() {
        const $list = $(this).siblings('.js-footer__list');

        if (!($(this).hasClass('is-open'))) {
            $('.js-footer__open-list, .js-footer__list').removeClass('is-open');
        }

        $([$list, this]).toggleClass('is-open');
    });

    changeFooter();
});

function changeFooter() {
    const $footer = $('.js-footer');
    let $stickyElement = $('.js-information__sticky').outerHeight() + 15;
    let $windowWidth = $(window).outerWidth();

    const mapToggleClass = {
        true: () => {
            $($footer).css('padding-bottom', $stickyElement);
        },
        false: () => {
            $($footer).removeAttr('style');
        }
    };

    mapToggleClass[$windowWidth < 1180]();

    $(window).resize(function() {
        $windowWidth = $(window).outerWidth();
        $stickyElement = $('.js-information__sticky').outerHeight() + 15;

        mapToggleClass[$windowWidth < 1180]();
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/footer.js